import useSWR from 'swr'

import * as T from 'types'

import { fetch } from '../../fetchers'

export const useStaticTopSavingsSoldListings = () => {
  const url = `/listings/top-savings-sold-contract/static`
  const response = useSWR<T.IListing[]>(url, fetch)
  return { ...response, topSavingsSoldListings: response.data }
}
